<div class="logo-container">
  <img [src]="src" [alt]="alt" [class]="class" />
</div>

